import type { VideoModuleAsset } from './video-module.types';

export function resolveVideoUrl(video?: VideoModuleAsset): string {
  return video?.videoUrl || video?.selectedUrl || video?.url || video?.previewUrl || '';
}

export function resolveVideoPoster(video?: VideoModuleAsset): string {
  return video?.previewImg || '';
}
